import React from 'react';
import { TrendingUp, TrendingDown, BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: BoxIcon;
  color: 'purple' | 'blue' | 'cyan' | 'green';
}
export function StatCard({
  title,
  value,
  change,
  trend,
  icon: Icon,
  color
}: StatCardProps) {
  const iconColorClasses = {
    purple: 'text-purple-500',
    blue: 'text-blue-500',
    cyan: 'text-cyan-500',
    green: 'text-green-500'
  };
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-133">
      <div className="flex items-start justify-between mb-3" data-id="element-134">
        <div className="flex-1" data-id="element-135">
          <p className="text-sm font-medium text-gray-600 mb-2" data-id="element-136">{title}</p>
          <p className="text-3xl font-bold text-gray-900" data-id="element-137">{value}</p>
        </div>
        <div className={`${iconColorClasses[color]}`} data-id="element-138">
          <Icon className="w-8 h-8" data-id="element-139" />
        </div>
      </div>
      <div className={`flex items-center gap-1 text-sm ${trend === 'up' ? 'text-green-600' : 'text-red-600'}`} data-id="element-140">
        {trend === 'up' ? <TrendingUp className="w-4 h-4" data-id="element-141" /> : <TrendingDown className="w-4 h-4" data-id="element-142" />}
        <span data-id="element-143">{change}</span>
      </div>
    </div>;
}